import React from "react";
import { Grid } from "@material-ui/core";
import { MASBRAN_APPS, SESSION_SECURITY_ROLE_KEY } from "../../utils/constants";
import Paper from "@material-ui/core/Paper";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import GroupIcon from "@material-ui/icons/Group";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    padding: theme.spacing(4, 2),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(4),
  },
  title: {
    textTransform: "upperCase",
    fontWeight: "bold",
    marginBottom: theme.spacing(2),
  },
  appPaper: {
    padding: theme.spacing(3),
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  appIcon: {
    fontSize: "6rem",
  },
}));

const LandingComponent = () => {
  const classes = useStyles();
  let navigate = useNavigate();
  const intl = useIntl();

  const roles = JSON.parse(sessionStorage.getItem(SESSION_SECURITY_ROLE_KEY));

  const handleRedirectToUsers = (route) => {
    navigate(route);
  };

  return (
    <div className={classes.pageContainer}>
      <Typography variant={"h4"} className={classes.title}>
        {intl.formatMessage({ id: "menu.home" })}
      </Typography>
      <Grid container spacing={4} direction={"column"}>
        {MASBRAN_APPS.map((app) =>
          roles?.includes(app.role) ? (
            <Grid item xs={3} key={app.name} onClick={() => handleRedirectToUsers(app.route)}>
              <Paper square className={classes.appPaper}>
                <GroupIcon className={classes.appIcon} />
                <Typography variant={"h5"}>{intl.formatMessage({ id: app.title })}</Typography>
              </Paper>
            </Grid>
          ) : null,
        )}
      </Grid>
    </div>
  );
};

export default LandingComponent;
